import { render, staticRenderFns } from "./EventData.vue?vue&type=template&id=4ccffc8a&scoped=true"
import script from "./EventData.vue?vue&type=script&lang=js"
export * from "./EventData.vue?vue&type=script&lang=js"
import style0 from "./EventData.vue?vue&type=style&index=0&id=4ccffc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccffc8a",
  null
  
)

export default component.exports